export function formatPnl(n, digits = 2) {
  if (!Number.isFinite(n)) return '—';
  const abs = Math.abs(n).toFixed(digits);
  if (n > 0) return `+$${abs}`;
  if (n < 0) return `-$${abs}`;
  return `$${abs}`;
}

export function formatPct(n) {
  if (!Number.isFinite(n)) return '—';
  return `${(n * 100).toFixed(1)}%`;
}

export function formatPf(n) {
  if (!Number.isFinite(n)) return n === Infinity ? '∞' : '—';
  return n.toFixed(2);
}

export function formatR(n) {
  if (!Number.isFinite(n)) return '—';
  const sign = n > 0 ? '+' : '';
  return `${sign}${n.toFixed(2)}R`;
}

export function formatEquityAxisTick(v) {
  if (!Number.isFinite(v)) return '';
  const abs = Math.abs(v);
  let body;
  if (abs >= 1000) body = `${(abs / 1000).toFixed(abs >= 10000 ? 0 : 1)}k`;
  else if (abs >= 100) body = abs.toFixed(0);
  else body = abs.toFixed(2);
  if (v > 0) return `$${body}`;
  if (v < 0) return `-$${body}`;
  return '$0';
}

export function formatRisk(n) {
  if (!Number.isFinite(n) || n <= 0) return '—';
  return `$${n.toFixed(2)}`;
}

export function formatQty(n) {
  if (!Number.isFinite(n)) return '—';
  if (Number.isInteger(n)) return String(n);
  return String(Number(n.toFixed(4)));
}

export function formatPrice(n) {
  if (!Number.isFinite(n)) return '—';
  const abs = Math.abs(n);
  const digits = abs >= 1 ? 2 : 4;
  return n.toLocaleString('en-US', { minimumFractionDigits: digits, maximumFractionDigits: digits });
}

const DATE_ONLY_RE = /^\d{4}-\d{2}-\d{2}$/;

function tzOpts(timeZone) {
  return timeZone ? { timeZone } : {};
}

export function dateFromChartTime(time) {
  if (time == null || time === '') return null;
  if (typeof time === 'object' && Number.isFinite(time.year)) {
    return new Date(time.year, (time.month || 1) - 1, time.day || 1);
  }
  if (typeof time === 'string' && DATE_ONLY_RE.test(time)) {
    const [y, m, d] = time.split('-').map(Number);
    return new Date(y, m - 1, d);
  }
  if (typeof time === 'number' && Number.isFinite(time)) {
    return new Date(time > 1e12 ? time : time * 1000);
  }
  const ms = Date.parse(time);
  return Number.isFinite(ms) ? new Date(ms) : null;
}

export function formatChartTick(time, tickMarkType, timeZone) {
  const d = dateFromChartTime(time);
  if (!d || Number.isNaN(d.getTime())) return '';
  const tz = tzOpts(timeZone);
  if (tickMarkType === 0) {
    return d.toLocaleDateString('en-US', { year: 'numeric', ...tz });
  }
  if (tickMarkType === 1) {
    return d.toLocaleDateString('en-US', { month: 'short', year: '2-digit', ...tz });
  }
  if (tickMarkType === 2 || typeof time === 'string' || (time && typeof time === 'object' && time.year != null)) {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: '2-digit', ...tz });
  }
  return d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true, ...tz });
}

export function formatChartCrosshair(time, timeZone) {
  const d = dateFromChartTime(time);
  if (!d || Number.isNaN(d.getTime())) return '';
  const tz = tzOpts(timeZone);
  if ((typeof time === 'string' && DATE_ONLY_RE.test(time))
    || (time && typeof time === 'object' && Number.isFinite(time.year))) {
    return d.toLocaleDateString('en-US', { month: 'short', day: 'numeric', year: 'numeric', ...tz });
  }
  const dateStr = d.toLocaleDateString('en-US', { month: 'numeric', day: 'numeric', year: '2-digit', ...tz });
  const timeStr = d.toLocaleTimeString('en-US', { hour: 'numeric', minute: '2-digit', hour12: true, ...tz });
  return `${dateStr} ${timeStr}`;
}

export function formatTradeTime(timestamp, timeZone) {
  const d = dateFromChartTime(timestamp);
  if (!d || Number.isNaN(d.getTime())) return '—';
  return d.toLocaleString('en-US', {
    month: 'short',
    day: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    ...tzOpts(timeZone),
  });
}
